import { applySpec, prop } from 'rambda'
import { factory } from '@store/utils'

export default {
  auto: '*',

  // for higher perf
  isFrozen: true,

  store: {
    getters: {
      sectionTemplates: (_, { query }) => query('sectionTemplate'),
      sectionTemplatesOptions: (_, { sectionTemplates }) => sectionTemplates
        .map(applySpec({
          label: prop('name'),
          value: prop('id'),
        })),

      sectionTemplateFactory: factory(() => ({
        promptId: null,
        name: null,
        icon: null,
        engine: 'curie',
        hasTitle: true,
        schema: {},
        fields: [],
        fieldsFill: null,
        fieldsFillArguments: [],
        questionsInitial: [],
        keyPoints: [],
        factsTemplates: [],
      })),
    },
  },
}
